const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');
const base64 = require('base-64');
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    validateBeneficiary(beneficiaryDetails, metaData) {
      const parameters = JSON.parse(Base64.decode(beneficiaryDetails));
      const url = getUrl('beneficiary/validate');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);

      const body = {
        beneficiaryDetails: parameters

      };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    addBeneficiaryDetails(inputParam, metaData) {
      const url = getUrl('beneficiary/');
      let parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      // body.beneficiary.cityName = body.beneficiary.city;
      
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    getBeneficiaryList(inputParam, metaData) {
      const url = getUrl('beneficiary/list');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const parameters = JSON.parse(Base64.decode(inputParam));
      
      const body = {
        paymentType: parameters.paymentType
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));

    },

    paymentsBenValidate(inputParam, metaData) {
      const url = getUrl('payments/beneficiaries/validate');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      }
      const decodedParams = JSON.parse(Base64.decode(inputParam));
      const body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        branchCode: parsedMetaData.portfolio.branchCode,
        channel: decodedParams.channel,
        deviceCode: decodedParams.deviceCode,
        txToken: decodedParams.txToken,
        psPosId: decodedParams.psPosId,
        beneficiaryId: decodedParams.beneficiaryId
      };
      return requestHandler(merge(reqOpts, {url, body}));
    },

    beneficiariesNamesPatch(inputParam, metaData) {
      const url = getUrl('beneficiaries/names/patch');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'PATCH',
        json: true
      };
      const decodedParams = JSON.parse(Base64.decode(inputParam));
      let body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        branchCode: parsedMetaData.portfolio.branchCode,
        channel: decodedParams.channel,
        deviceCode: decodedParams.deviceCode,
        txToken: decodedParams.txToken,
        beneficiaryId: decodedParams.beneficiaryId
      };
      return requestHandler(merge(reqOpts, {url, body} ));
    }

  };
}

module.exports = apiFactory;